import React from 'react';
import ReactDOM from 'react-dom';
import { Card as BSCard} from 'reactstrap';
import printer from '../base/utils/printer.js';
import C from '../C';
import Roles from '../base/Roles';
import Misc from '../base/components/Misc';
import ActionMan from '../plumbing/ActionMan';
import DataStore, { getDataPath } from '../base/plumbing/DataStore';
import ServerIO from '../plumbing/ServerIO';
import {getId} from '../base/data/DataClass';
import Money from '../base/data/Money';
import PropControl from '../base/components/PropControl';
import SavePublishDeleteEtc from '../base/components/SavePublishDeleteEtc.jsx';


function JournalPage() {
	const blocked = Misc.CheckAccess({can: 'admin'});
	if (blocked) return blocked;

	return (
		<div className="">
			<h2 className="alert alert-warning">Good-Loop Data Journal (hack space)</h2>

			<p>ONLY use this if you know what you're doing</p>

			<PokeDataLog />
		</div>
	);
}


function PokeDataLog() {
	if ( ! Roles.isDev()) {
		return null;
	}
	let path = getDataPath({status:C.KStatus.DRAFT, type:C.TYPES.JournalEntry, id:C.newId});
	// Most settings go into the props map for a DatalogEvent JournalEntry.e. See JournalEntry.java
	const pathe = path.concat('e');
	const pathprops = pathe.concat('props');
	// a (nearly) blank poke
	let pokebase= {
		makeEvent: true,
		e:{props:{via:'portal'}}
	};	
	let poke = DataStore.getValue(path) || DataStore.setValue(path, pokebase, false);
	if ( ! poke.e) poke.e = {};
	if ( ! poke.e.props) poke.e.props = {};
	const pokeProps = poke.e.props;
	const pvPokes = ActionMan.list({type:C.TYPES.JournalEntry, status:C.KStatus.ALL_BAR_TRASH});

	let spendq = `vert:${pokeProps.vert} pub:${pokeProps.pub} campaign:${pokeProps.campaign} cid:${pokeProps.cid}`;
	let pvSpendData = DataStore.fetch(['widget','PokeDataLog','spend', spendq],
		() => ServerIO.getSpendData({q:spendq})
	);
	let pvDonData = DataStore.fetch(['widget','PokeDataLog','don', spendq],
		() => ServerIO.getDonationsData({q:spendq})
	);
	let pvAllSpend = pokeProps.vert ? DataStore.fetch(['widget','PokeDataLog','BudgetSpend', pokeProps.vert],
		() => ServerIO.getAllSpend({vert:pokeProps.vert})
	) : {};

	// HACK! cos the backend wants an array, but select spits out strings
	if (poke.e.s_eventType) {
		poke.e.evt = [poke.e.s_eventType];
	}

	let widgetpath = ['widget','journal'];
	let widgetprops = DataStore.getValue(widgetpath) || {};
	// HACK Money
	// TODO dollars

	return (<>
		<BSCard>
			<p>This tool lets you manually poke missing campaign data into the system.
				It is for activity that wasn't recorded by our usual logging.</p>
	
			<PropControl prop="s_eventType" label="Event" path={pathe} type="select"
				options={['render','visible','open','minview','click','donation','spend','spendadjust','adhoc','campaigndonation']}
			/>
			<div>{/* show desc from TrafficReport */}</div>
			<PropControl prop="count" label="Count" path={pathe} type="number" help="Number of basic events (e.g. views) that this represents." />

			<PropControl prop="price" label="Total Price" path={widgetpath} type="Money" saveFn={
				({value}) => { pokeProps.price = Money.value(value); pokeProps.curr = value.currency; }
			} />
			<Misc.Money amount={pokeProps.priceusd} currency="USD" />
			
			<PropControl prop="dntn" label="Total Donation" path={widgetpath} type="Money" saveFn={
				({value}) => { pokeProps.dntn = Money.value(value); pokeProps.curr = value.currency; }
			} />
			<Misc.Money amount={pokeProps.dntnusd} currency="USD" />

			<PropControl prop="pub" label="Publisher" path={pathprops} />
			<PropControl type="DataItem" prop="campaign" label="Advert Campaign" path={pathprops} 
				itemType={C.TYPES.Campaign} status={C.KStatus.PUB_OR_DRAFT} />
			<PropControl type="DataItem" prop="vert" label="Advert" path={pathprops} 
				itemType={C.TYPES.Advert} status={C.KStatus.PUB_OR_DRAFT} />
			<PropControl prop="cid" label="Charity ID" path={pathprops}
				help="If blank, unallocated spends will get auto-allocated via spendadjusts"
				type="DataItem" status={C.KStatus.PUB_OR_DRAFT}
			/>
			<PropControl prop="via" label="Via" path={pathprops} />

			<PropControl prop="makeEvent" type="checkbox" label="Create an event in DataLog" path={path} />
			<PropControl prop="makeBid" type="checkbox" label="Create a Bid" path={path} />
			<PropControl prop="modifyBudget" type="checkbox" label="Modify advert budget" path={path}
				help="Budgets are linked to an Advert campaign" disabled={ ! DataStore.getValue(pathprops.concat('campaign'))}
			/>

			<SavePublishDeleteEtc type={C.TYPES.JournalEntry} id={C.newId} />
		</BSCard>

		<h5>Stats</h5>
		Spend {JSON.stringify(pvSpendData.value)}
		
		<div>
			All Spend for {pokeProps.vert}
			{JSON.stringify(pvAllSpend.value)}
		</div>

		<div>Donations
			{JSON.stringify(pvDonData.value)}
		</div>
		
		minviews for this pub/vert
		clicks

		<h5>List of Data-Journal Pokes</h5>
		{pvPokes.value && pvPokes.value.hits?
			pvPokes.value.hits.map(pk => <div key={pk.id} className="well">{JSON.stringify(pk)}</div>)
			: <Misc.Loading />}
	</>);
}

export default JournalPage;
